import React, { Component } from 'react'
import { Input, AutoComplete } from 'antd'
import { loadGoogleMaps } from '@utils/loadGoogleMaps'
import { textInput } from '../EditSubStoDataPopup/edit-sub-sto.scss'

interface Props {
    value?: string
    onChange?: (value: string) => void
    placeholder?: string
    disabled?: boolean
    className?: string
}

interface State {
    suggestions: Array<{ value: string; text: string; placeId: string }>
    ready: boolean
}

class AddressAutocomplete extends Component<Props, State> {
    _autocompleteService: any = null
    _sessionToken: any = null

    state: State = {
        suggestions: [],
        ready: false
    }

    componentDidMount() {
        loadGoogleMaps()
            .then(() => {
                const google = (window as any).google
                this._autocompleteService = new google.maps.places.AutocompleteService()
                this._sessionToken = new google.maps.places.AutocompleteSessionToken()
                this.setState({ ready: true })
            })
            .catch(err => {
                console.error('Google Maps load error:', err)
                this.setState({ ready: true })
            })
    }

    handleSearch = (value: string) => {
        const { onChange } = this.props
        if (onChange) onChange(value)

        if (!value || value.length < 2 || !this._autocompleteService) {
            this.setState({ suggestions: [] })
            return
        }

        this._autocompleteService.getPlacePredictions(
            {
                input: value,
                componentRestrictions: { country: 'il' },
                sessionToken: this._sessionToken,
                types: ['address']
            },
            (predictions: any[], status: string) => {
                const google = (window as any).google
                if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
                    this.setState({ suggestions: [] })
                    return
                }

                this.setState({
                    suggestions: predictions.map(p => ({
                        value: p.description,
                        text: p.description,
                        placeId: p.place_id
                    }))
                })
            }
        )
    }

    handleSelect = (value: string) => {
        const { onChange } = this.props
        if (onChange) onChange(value)

        const google = (window as any).google
        if (google && google.maps && google.maps.places) {
            this._sessionToken = new google.maps.places.AutocompleteSessionToken()
        }

        this.setState({ suggestions: [] })
    }

    render() {
        const { value, placeholder, disabled, className } = this.props
        const { suggestions } = this.state

        return (
            <AutoComplete
                value={value}
                dataSource={suggestions.map(s => s.value)}
                onSearch={this.handleSearch}
                onSelect={this.handleSelect}
                placeholder={placeholder}
                disabled={disabled}
                style={{ width: '100%' }}
                dropdownStyle={{ direction: 'rtl', textAlign: 'right' }}
            >
                <Input
                    className={className || textInput}
                    style={{ direction: 'rtl', textAlign: 'right' }}
                />
            </AutoComplete>
        )
    }
}

export default AddressAutocomplete
